import React, { useState, useCallback } from 'react';
import { createRoot } from 'react-dom/client';
import { AuthProvider } from './hooks/useAuth';
import { theme } from './theme';

// Screens
import { LandingScreen } from './components/screens/LandingScreen';
import { BrowseScreen } from './components/screens/BrowseScreen';
import { NewRequestScreen } from './components/screens/NewRequestScreen';
import { RequestDetailScreen } from './components/screens/RequestDetailScreen';
import { MakerProfileScreen } from './components/screens/MakerProfileScreen';
import { MyPageScreen } from './components/screens/MyPageScreen';
import { MakerRegisterScreen } from './components/screens/MakerRegisterScreen';
import { OrdersScreen } from './components/screens/OrdersScreen';
import { ChatScreen } from './components/screens/ChatScreen';
import { ServiceCreateScreen } from './components/screens/ServiceCreateScreen';
import { SettingsScreen } from './components/screens/SettingsScreen';

// Layout
import { Header } from './components/layout/Header';
import { BottomNav } from './components/layout/BottomNav';

function App() {
  const [screen, setScreen] = useState('landing');
  const [selectedRequest, setSelectedRequest] = useState(null);
  const [selectedMaker, setSelectedMaker] = useState(null);
  const [chatRequestId, setChatRequestId] = useState(null);

  const navigate = useCallback((screenName, data) => {
    setScreen(screenName);
    if (screenName === 'request-detail') setSelectedRequest(data);
    if (screenName === 'maker-profile') setSelectedMaker(data);
    if (screenName === 'chat') setChatRequestId(data);
  }, []);

  const renderScreen = () => {
    switch (screen) {
      case 'landing':
        return <LandingScreen onNavigate={navigate} />;
      case 'browse':
        return <BrowseScreen onNavigate={navigate} />;
      case 'new-request':
        return <NewRequestScreen onNavigate={navigate} />;
      case 'request-detail':
        return <RequestDetailScreen requestId={selectedRequest} onNavigate={navigate} />;
      case 'maker-profile':
        return <MakerProfileScreen makerId={selectedMaker} onNavigate={navigate} />;
      case 'my-page':
        return <MyPageScreen onNavigate={navigate} />;
      case 'maker-register':
        return <MakerRegisterScreen onNavigate={navigate} />;
      case 'orders':
        return <OrdersScreen onNavigate={navigate} />;
      case 'chat':
        return <ChatScreen requestId={chatRequestId} onNavigate={navigate} />;
      case 'service-create':
        return <ServiceCreateScreen onNavigate={navigate} />;
      case 'settings':
        return <SettingsScreen onNavigate={navigate} />;
      default:
        return <LandingScreen onNavigate={navigate} />;
    }
  };

  return (
    <div style={{
      maxWidth: theme.maxWidth,
      margin: '0 auto',
      minHeight: '100vh',
      background: theme.bg,
      position: 'relative',
    }}>
      <Header onNavigate={navigate} currentScreen={screen} />
      <main style={{ paddingBottom: '80px', paddingTop: '60px' }}>
        {renderScreen()}
      </main>
      <BottomNav currentScreen={screen} onNavigate={navigate} />
    </div>
  );
}

createRoot(document.getElementById('root')).render(
  <AuthProvider>
    <App />
  </AuthProvider>
);
